
import React, { useState } from 'react';

import { ILuxuryHome } from '@share/common-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCircle } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
  amenitiesRef: React.RefObject<HTMLDivElement> | undefined;
}

const AmenitiesIcon = () => {
  return <FontAwesomeIcon icon={faCircle} style={{ color: '#8B6F40', marginRight: 10, fontSize: 8 }} />;
}

const AmenitiesTitleIcon = () => {
  return <FontAwesomeIcon icon={faCheck} style={{ color: '#8B6F40' }} />;
}

export const LuxuryHomesDetailsAmenities: React.FC<IProps> = ({ home, amenitiesRef }) => {

  const [showMoreAmenities, setShowMoreAmenities] = useState(false);
  
  const mainUnit = home?.units?.[0];

  return (  
    <section id="amenities" className="property-section" ref={amenitiesRef}>
      <h2>Amenities</h2>
      <div className="amenities-grid">
        {!!mainUnit?.amenities?.length && (
          <div className="amenity-group">
            <h3><AmenitiesTitleIcon /> Amenities</h3>
            <ul>
              {mainUnit?.amenities?.slice(0, showMoreAmenities ? mainUnit?.amenities?.length : 5).map((item: any) => (
                <li key={item.name}><AmenitiesIcon /> {item.name}</li>
              ))}
            </ul>

            {mainUnit?.amenities?.length > 5 &&
              <button className="read-more" onClick={() => setShowMoreAmenities(!showMoreAmenities)}>
                Read {showMoreAmenities ? 'less' : 'more'}
              </button>}
          </div>)}

        {!!mainUnit?.kitchenEquipments?.length && (
          <div className="amenity-group">
            <h3><AmenitiesTitleIcon /> Kitchen</h3>
            <ul>
              {mainUnit?.kitchenEquipments?.map((item: any) => (
                <li key={item.name}><AmenitiesIcon /> {item.name}</li>
              ))}
            </ul>
          </div>)}

        {(!!home?.smoking?.length || !!home?.pets?.length) && (
          <div className="amenity-group">
            <h3><AmenitiesTitleIcon /> Policies</h3>
            <ul>
              {home?.smoking?.map((s: string) => (
                <li key={s}><AmenitiesIcon /> {s}</li>))}
              {home?.pets?.map((s: string) => (
                <li key={s}><AmenitiesIcon /> {s}</li>))}
            </ul>
          </div>)}
      
      </div>
    </section>
  );
};
